import React from 'react';
import * as consts from 'config/consts';
import {
  Transaction,
  categoryStrToTransactionCategoryType,
} from 'hooks/useGetTransactions';
import NumberLabel from 'components/features/utils/NumberLabel';
import { AboutExchangeRateModalButton } from 'components/features/home/PortfolioStuffing/asset/PortfolioStuffingAsset';
import { transactionsCategoryTypeToIconClassName } from 'components/features/security-accounts/PositionListTransaction';
import Icon from 'components/commons/icon/Icon';

type TransactionItemProps = {
  borderTop: React.ReactElement | false;
  transaction: Transaction;
  onAccountItemClick: (account: string) => void;
};

export const TransactionItem = ({
  borderTop,
  transaction,
  onAccountItemClick,
}: TransactionItemProps): React.ReactElement => {
  return (
    <>
      {borderTop}
      <div
        className="flex items-center mx-3 py-4 cursor-pointer"
        onClick={(): void => onAccountItemClick(transaction.account)}>
        <div
          className={`w-12 h-12 text-2xl text-center leading-12 text-bluegray-500 ${transactionsCategoryTypeToIconClassName(
            categoryStrToTransactionCategoryType(
              typeof transaction.category === 'string'
                ? transaction.category
                : ''
            ) ?? consts.TransactionsCategoryType.未定
          )}`}
        />
        <div className="w-full mx-3">
          <div className="text-sm font-bold">
            {transaction.categoryText} {transaction.description}
          </div>
          <div className="flex">
            <div className="text-sm">{transaction.brokerName}</div>
            <div className="flex-grow flex justify-end">
              <NumberLabel
                value={transaction.amount}
                unitName="円"
                classNames={['text-base', 'text-xs mt-1 ml-1']}
              />
            </div>
          </div>
          {transaction.amountUSD !== null && (
            <div className="flex flex-grow" onClick={e => e.stopPropagation()}>
              <NumberLabel
                value={transaction.amountUSD}
                bracketType={consts.BracketType.round}
                unitName="USD"
                className="ml-auto mr-3"
                classNames={['text-sm', 'text-sm ml-1']}
              />
              <AboutExchangeRateModalButton isShowMessage={false} />
            </div>
          )}
        </div>
        <Icon name="chevron-right" className="text-2xl text-bluegray-500" />
      </div>
    </>
  );
};
